import { render, staticRenderFns } from "./PostFilterOptions.vue?vue&type=template&id=3040b8cc&"
import script from "./PostFilterOptions.vue?vue&type=script&lang=js&"
export * from "./PostFilterOptions.vue?vue&type=script&lang=js&"
import style0 from "./PostFilterOptions.vue?vue&type=style&index=0&id=3040b8cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports